

const KLAVIYO_API_KEY = import.meta.env.VITE_KLAVIYO_PUBLIC_API_KEY;
const KLAVIYO_API_URL = `https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_API_KEY}`;

const createEventPayload = ({
  eventName,
  email = null,
  eventProperties = {},
  profileProperties = {},
}) => {
  return {
    data: {
      type: "event",
      attributes: {
        properties: eventProperties,
        metric: {
          data: {
            type: "metric",
            attributes: {
              name: eventName
            },
          },
        },
        profile: {
          data: {
            type: "profile",
            attributes: {
              email,
              properties: profileProperties,
            },
          },
        },
      },
    },
  };
};

// Core tracking methods
const sendKeepalive = async (payload) => {
  try {
    const apiUrl = KLAVIYO_API_URL;
    if (!apiUrl) return false;

    const response = await fetch(apiUrl, {
      method: "POST",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        revision: "2024-02-15",
      },
      body: JSON.stringify(payload),
    });
    return response.ok;
  } catch (error) {
    console.error("Keepalive request error:", error);
    return false;
  }
};

const sendAsync = async (payload) => {
  try {
    const apiUrl = KLAVIYO_API_URL;
    if (!apiUrl) return false;

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2024-02-15",
      },
      credentials: "omit",
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Failed to track event: ${response.statusText}`);
    }

    return true;
  } catch (error) {
    console.error("Error sending async request:", error);
    return false;
  }
};

// Generic tracking methods
export const trackEvent = async (params) => {
  console.log("Tracking event:", params);
  const payload = createEventPayload(params);
  return sendAsync(payload);
};

export const trackEventKeepalive = (params) => {
  console.log("Tracking keepalive event:", params);
  const payload = createEventPayload(params);
  return sendKeepalive(payload);
};

export const trackUnavailableSizeEmailSubmitted = async ({ email, leftFootLength, rightFootLength }) => {
  return trackEvent({
    eventName: "Unavailable Size Email Submitted",
    email,
    eventProperties: {
      left_foot_length_mm: leftFootLength,
      right_foot_length_mm: rightFootLength,
    },
    profileProperties: {
      left_foot_length_mm: leftFootLength,
      right_foot_length_mm: rightFootLength,
    },
  });
};
